import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Section } from 'foundations-components/transitional/components/Section';
import { jsx as _jsx } from "react/jsx-runtime";
export function NoEditPermissionsAlert() {
  return /*#__PURE__*/_jsx(Section, {
    children: /*#__PURE__*/_jsx(Alert, {
      type: "tip",
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "subscriptions.permissions.noEditRecordPermissionsWarning"
      })
    })
  });
}